import { useForm } from 'react-hook-form';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLock } from '@fortawesome/free-solid-svg-icons'; // Import the specific icon
import { handleAdminForgotPassword } from '../services/APIClient';
import { STATUS_CODES } from '../utils/statusCode';
import Toster from '../utils/Toaster';
import { useLoader } from '../contexts/LoaderContext';

const ForgotPasswordModal = ({ isOpen, onClose, setIsModalOpen, setIsResetPasswordModalOpen, setEmail }) => {

    // Initialize useForm hook
    const { register, setValue, handleSubmit, formState: { errors } } = useForm();
    const { setLoading } = useLoader();

    const onSubmit = async (formdata) => {
        const postData = new FormData();
        postData.append("email", formdata.email);

        try {
            setLoading(true);
            const response = await handleAdminForgotPassword(postData);
            if (response?.code == STATUS_CODES.SUCCESS) {
                Toster("Code sent successfully", "success");

                setEmail(formdata.email);
                setIsModalOpen(false)
                setIsResetPasswordModalOpen(true)
                setValue('email', '')
            }
            setLoading(false);
        } catch (error) {
            setLoading(false);
        }

    };

    const handleClose = () => {
        setValue('email', '')
        onClose();
    }

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg shadow-lg m-10 p-6 w-full max-w-md">
                <div className="flex justify-center mb-4">
                    <div className="bg-gray-100 p-4 rounded-full">
                        <FontAwesomeIcon
                            icon={faLock}
                            className="text-gray-800 text-4xl" // Increase the size of the icon
                        />
                    </div>
                </div>
                <h2 className="text-xl font-semibold text-center mb-2">Forgot Password?</h2>
                <p className="text-gray-600 text-center mb-4">
                    Enter your email address and we’ll send you a code to reset your password.
                </p>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <div className="mb-4">
                        <label
                            htmlFor="email"
                            className="block text-sm font-medium text-gray-700 mb-1"
                        >
                            Email
                        </label>
                        <input
                            type="email"
                            id="email"
                            name="email"
                            // autoComplete='off'
                            {...register('email', {
                                required: 'Email is required.',
                                pattern: {
                                    value: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                                    message: 'Invalid email format.',
                                },
                                minLength: {
                                    value: 3,
                                    message: 'Email must be at least 3 characters long.',
                                },
                                maxLength: {
                                    value: 150,
                                    message: 'Email cannot exceed 150 characters.',
                                },
                            })}
                            className={`w-full px-4 py-2 border ${errors.email
                                ? 'border-red-500'
                                : 'border-gray-300'
                                } rounded-md focus:outline-none focus:ring-2 ${errors.email
                                    ? 'focus:ring-red-500'
                                    : 'focus:ring-blue-500'
                                }`}
                            placeholder="Enter your email"
                        />
                        {errors.email && (
                            <p className="text-red-500 text-sm mt-1">
                                {errors.email.message}
                            </p>
                        )}
                    </div>
                    <div className="flex justify-between">
                        <button
                            type="button"
                            className="px-4 py-2 bg-gray-100 text-gray-700 rounded-md hover:bg-gray-200"
                            onClick={handleClose}
                        >
                            Cancel
                        </button>
                        <button
                            type="submit"
                            className="px-4 py-2 bg-gray-700 text-white rounded-md hover:bg-gray-900"
                        >
                            Reset
                        </button>
                    </div>
                </form>
            </div>

            {/* Reset Password Modal */}

        </div>
    );
};

export default ForgotPasswordModal;